<template>
  <div :class="className || 'mt-2'">
    <v-btn
      :block="!noBlock"
      small
      color="secondary"
      @click="download(url)"
    >
      {{label || 'Download Video'}}
      <v-icon right>mdi-download</v-icon>
    </v-btn>
    <!-- Linear Progress Loading Dialog -->
    <!-- <linear-progress :loading="loading" text="Downloading..." :disablePersistent="true"/> -->
    <!-- End Linear Progress Loading Dialog -->        
  </div>
</template>
<script>
  // import LinearProgress from './LinearProgress';
  // import utils from '@/utils';
  export default {
    name: 'BtnDownload',
    props: {
      url: String,
      label: String,
      className: String,
      noBlock: Boolean
    },
    // components: {
    //   LinearProgress
    // },
    data() {
      return {
        loading: false
      }
    },
    methods: {
      async download(url) {
        if (!url) return
        // this.loading = true
        // try {
        //   await utils.func.downloadFile(url.split('/').pop(), url)
        //   this.loading = false
        // } catch (error) {
        //   this.loading = false
        // }
        // url = url.replace('.mp4', '.mov') // replace mp4 to mov to prevent browser from opening new tab
        var link = document.createElement('a');
        link.href = url;
        link.download = url.substr(url.lastIndexOf('/') + 1);
        link.click();
      }
    }
  }
</script>



// WEBPACK FOOTER //
// BtnDownload.vue?ce8446bc